module.exports = __webpack_public_path__ + "static/media/woman-looking-at-laptop.b842d753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LandingPage/woman-looking-at-laptop.jpg
// module id = 1074
// module chunks = 0